// Generated by ReScript, PLEASE EDIT WITH CARE


var sliderMarkings = [
  "0",
  "50",
  "100"
];

var slider_colors = [
  "#DF321B",
  "#F5A424",
  "#0E8155"
];

var sliderBoxBorderColors = [
  "#DF321B",
  "#F5A424",
  "0E8155"
];

var sliderBoxBGColors = [
  "#FFF4F0",
  "#FEC",
  "#E3FCF4"
];

var fill_color = [
  "#FEE9BF",
  "#FDCE9F",
  "#F8D1CB",
  "#F8D1CB"
];

var inner_stroke_color = [
  "#A9730A",
  "#C46100",
  "#BD2A16",
  "#BD2A16"
];

var outer_stroke_color = [
  "#FFC857",
  "#FF8C1A",
  "#E04631",
  "#E04631"
];

var span_color = [
  "#32926D",
  "#FFCB6C",
  "#FF8C1A",
  "#E04631",
  "#E04631"
];

var inactive_slider_box_style = [
  "rgba(78, 82, 91, 0.36)",
  "#F4F5F6"
];

var active_slider_box_style = [
  "#DB230A",
  "#FFF4F0"
];

var sliderMarking1 = "0";

var sliderMarking2 = "50";

var sliderMarking3 = "100";

var iBtnTitle = "i";

var learnMoreBtnTitle = "learn_more";

var iBtnClickEventName = "i button <Click>";

var learnMoreBtnClickEventName = "learn more button <Click>";

var errorCmpTitle = "Something happened from our side";

var reloadBtnText = "Click Here to Reload";

var inactive_span_color = "#CED1D5";

var suspended_tooltip_color = "#DB230A";

var unsuspended_tooltip_color = "#ffffff";

var safe_milestone_color = "#32926D";

var danger_milestone_color = "#E04631";

var inactive_milestone_color = "#CED1D5";

export {
  sliderMarkings ,
  slider_colors ,
  sliderBoxBorderColors ,
  sliderBoxBGColors ,
  sliderMarking1 ,
  sliderMarking2 ,
  sliderMarking3 ,
  iBtnTitle ,
  learnMoreBtnTitle ,
  iBtnClickEventName ,
  learnMoreBtnClickEventName ,
  errorCmpTitle ,
  reloadBtnText ,
  fill_color ,
  inner_stroke_color ,
  outer_stroke_color ,
  span_color ,
  inactive_span_color ,
  inactive_slider_box_style ,
  active_slider_box_style ,
  suspended_tooltip_color ,
  unsuspended_tooltip_color ,
  safe_milestone_color ,
  danger_milestone_color ,
  inactive_milestone_color ,
  
}
/* No side effect */
